export default __webpack_public_path__ + "static/media/remind_bell.f4797b13.png";